import { SAVE_IN_PROGRESS, SAVE_PROCESS_DONE } from "./fetchingDataActions";
import { fetchItemsWS } from '../webservices/fetchWS';
import { createItemWs, updateItemWs } from "../webservices/saveWS";
import { sendGroupMessageWs } from "../webservices/groupMessgesWS";
import { addUsersToGroups, grantGroupPermissions } from "../webservices/userGroupsWs";
import { toast } from "react-toastify";
import { Storage } from 'aws-amplify';
import _ from "lodash";
import { UserGroupDTO } from "./DTOs/UserGroupDTO";
import { GroupUserDTO } from "./DTOs/GroupUserDTO";
import { UserDTO } from "./DTOs/UserDTO";
import { GroupMessageDTO } from "./DTOs/GroupMessageDTO";

// Helper function to update user app permissions
const updateUserAppPermissions = (userId, tenantId, hasAccess, getState) => {
  const queryParams = {
    PK: `USERS`,
    SK: `USER%23${userId}`,
  };

  console.log('Querying user with params:', queryParams);
  console.log('User ID:', userId, 'Tenant ID:', tenantId, 'Has Access:', hasAccess);

  return fetchItemsWS('get-dynamodb', queryParams, getState)
    .then((result) => {
      console.log('Fetched user data:', result);
      const users = result.Items.filter((item) => item.status !== 'isDeleted');
      if (users.length > 0) {
        const user = users[0];
        console.log('User before update:', user);
        // Handle both array format (from API) and SS format (from DynamoDB) and Map format
        const currentPermissions = user.appPermissions?.SS || user.appPermissions || [];
        console.log('Current permissions:', currentPermissions);

        // Convert to Map format for easier handling
        let permissionsMap = {};
        if (Array.isArray(currentPermissions)) {
          // Convert from array to map
          currentPermissions.forEach(tenantId => {
            permissionsMap[tenantId] = true;
          });
        } else if (typeof currentPermissions === 'object') {
          // Already a map
          permissionsMap = { ...currentPermissions };
        }

        if (hasAccess) {
          permissionsMap[tenantId] = true;
        } else {
          permissionsMap[tenantId] = false;
        }

        console.log('New permissions map:', permissionsMap);

        const updatedUser = {
          ...user,
          appPermissions: Object.keys(permissionsMap).length > 0 ? permissionsMap : null
        };
        console.log('Updated user object:', updatedUser);
        return updateItemWs(updatedUser, getState);
      } else {
        console.log(`User ${userId} not found, skipping permission update`);
        return Promise.resolve();
      }
    })
    .catch((err) => {
      console.log('Error fetching user:', err);
      console.log('Query params that failed:', queryParams);
      return Promise.resolve(); // Don't fail the entire operation
    });
};


/// User Group Actions ///

export const FETCHING_USER_GROUPS_ACTION = 'FETCHING_USER_GROUPS_ACTION';
export const FETCH_USER_GROUPS_SUCCESS_ACTION = 'FETCH_USER_GROUPS_SUCCESS_ACTION';
export const FETCH_USER_GROUPS_ERROR_ACTION = 'FETCH_USER_GROUPS_ERROR_ACTION';

export const fetchUserGroupsAction = (tenant) => {
  const queryParams = {
    PK: `${tenant.id}%23GROUPS`,
    SK: `GROUP%23`,
  };

  return (dispatch, getState) => {
    dispatch({ type: FETCHING_USER_GROUPS_ACTION });
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        let items = result.Items;
        items = items.filter((item) => item.status !== 'isDeleted');
        dispatch({ type: FETCH_USER_GROUPS_SUCCESS_ACTION, payload: items });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_USER_GROUPS_ERROR_ACTION, err });
      });
  };
}


export const USER_GROUP_ADD_ACTION = "USER_GROUP_ADD_ACTION";
export const USER_GROUP_EDIT_ACTION = "USER_GROUP_EDIT_ACTION";

export const saveUserGroupAction = (tenant, group, isNew) => {
  return (dispatch, getState) => {
    const saveObject = new UserGroupDTO(group, tenant);
    dispatch({ type: SAVE_IN_PROGRESS });
    if (isNew === true) {
      createItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: USER_GROUP_ADD_ACTION, payload: result.data });

          // Grant mobile permissions if mobileAppAccess is enabled
          if (group.mobileAppAccess) {
            const permissionData = {
              tenantId: tenant.id,
              groupId: result.data.id,
              access: group.mobileAppAccess
            };
            grantGroupPermissions(permissionData, getState);
            toast.info("User permissions are being updated. This may take a few minutes to complete.");
          }

          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success("User Group Successfully Created");
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.error("Failed to create new user group. Please try again");
        });
    }
    else {
      updateItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: USER_GROUP_EDIT_ACTION, payload: result.data });

          // Grant mobile permissions based on mobileAppAccess value
          const permissionData = {
            tenantId: tenant.id,
            groupId: result.data.id,
            access: group.mobileAppAccess
          };
          grantGroupPermissions(permissionData, getState);
          toast.info("User permissions are being updated. This may take a few minutes to complete.");

          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success("User Group Successfully Updated");
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success("Failed to update the user group. Please try again");
        });
    }
  }
}

export const USER_GROUP_DELETE_ACTION = 'USER_GROUP_DELETE_ACTION';

export const deleteUserGroupsAction = (group, tenant) => {
  return (dispatch, getState) => {
    const saveObject = new UserGroupDTO(group, tenant);
    saveObject.status = "isDeleted";
    updateItemWs(saveObject, getState)
      .then((result) => {
        dispatch({ type: USER_GROUP_DELETE_ACTION, payload: result.data.id });
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.success("User Group Deleted Successfully");
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.error("Failed to delete user group. Please try again");
      });

  }
}


/// Group User Actions ///

export const FETCHING_GROUP_USERS_ACTION = 'FETCHING_GROUP_USERS_ACTION';
export const FETCH_GROUP_USERS_SUCCESS_ACTION = 'FETCH_GROUP_USERS_SUCCESS_ACTION';
export const FETCH_GROUP_USERS_ERROR_ACTION = 'FETCH_GROUP_USERS_ERROR_ACTION';
export const FETCH_ITEMS_SUCCESS_ACTION = 'FETCH_ITEMS_SUCCESS_ACTION';
export const CLEAR_LASTEVALUATEDKEY = "CLEAR_LASTEVALUATEDKEY";
export const CLEAR_GROUPUSERS = "CLEAR_GROUPUSERS";


export const fetchGroupUserAction = (group) => {
  const queryParams = {
    PK: `${group.tenantId}%23GROUP%23${group.id}`,
    SK: `GROUPUSER%23`,
    limit: 50,
  };

  return (dispatch, getState) => {
    const state = getState()
    const lastEvaluatedKey = state.lastEvaluatedKey
    if (lastEvaluatedKey) {
      const encodedPK = encodeURIComponent(lastEvaluatedKey.PK);
      const encodedSK = encodeURIComponent(lastEvaluatedKey.SK);
      const exclusiveStartKey = {
        PK: encodedPK,
        SK: encodedSK
      };
      queryParams.ExclusiveStartKey = JSON.stringify(exclusiveStartKey);
    }
    dispatch({ type: FETCHING_GROUP_USERS_ACTION });
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        let items = result.Items;
        let lastKey = result.LastEvaluatedKey;
        items = items.filter((item) => item.status !== 'isDeleted');
        dispatch({ type: FETCH_GROUP_USERS_SUCCESS_ACTION, payload: items });
        if (lastKey !== undefined) {
          dispatch({ type: FETCH_ITEMS_SUCCESS_ACTION, payload: lastKey });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_GROUP_USERS_ERROR_ACTION, err });
      });
  };
}

export const clearSelectedUserGroupUsersAction = () => {
  return (dispatch, getState) => {
    dispatch({ type: CLEAR_GROUPUSERS });
  };
}

export const clearLastEvaluatedKeyAction = () => {
  return (dispatch, getState) => {
    dispatch({ type: CLEAR_LASTEVALUATEDKEY });
  };
}

export const FETCHING_SEARCHED_GROUP_USERS_ACTION = 'FETCHING_SEARCHED_GROUP_USERS_ACTION';
export const FETCH_SEARCHED_GROUP_USERS_SUCCESS_ACTION = 'FETCH_SEARCHED_GROUP_USERS_SUCCESS_ACTION';
export const FETCH_SEARCHED_GROUP_USERS_ERROR_ACTION = 'FETCH_SEARCHED_GROUP_USERS_ERROR_ACTION';

export const fetchSearchedUserAction = (group, term) => {
  const queryParams = {
    PK: `${group.tenantId}%23GROUP%23${group.id}`,
    SK: `GROUPUSER%23${term}`,
    limit: 30,
  };

  return (dispatch, getState) => {
    const state = getState()
    dispatch({ type: FETCHING_SEARCHED_GROUP_USERS_ACTION });
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        let items = result.Items;
        items = items.filter((item) => item.status !== 'isDeleted');
        dispatch({ type: FETCH_SEARCHED_GROUP_USERS_SUCCESS_ACTION, payload: items });
        if (result.items === 0) {
          toast.error("No user mathcing search input found")
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_SEARCHED_GROUP_USERS_ERROR_ACTION, err });
      });
  };
}

export const GROUP_USER_ADD_ACTION = "GROUP_USER_ADD_ACTION";
export const GROUP_USER_EDIT_ACTION = "GROUP_USER_EDIT_ACTION";

export const saveGroupUserAction = (user, group, isNew) => {
  return (dispatch, getState) => {
    const saveObject = new GroupUserDTO(user, group);
    dispatch({ type: SAVE_IN_PROGRESS });
    if (isNew === true) {
      createItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: GROUP_USER_ADD_ACTION, payload: result.data });

          // Wait for user creation, then update permissions if group has mobile access
          return dispatch(saveUserAction(user, group));
        })
        .then(() => {
          if (group.mobileAppAccess) {
            // Add small delay to ensure user is created before updating permissions
            setTimeout(() => {
              updateUserAppPermissions(user.contact_nr, group.tenantId, true, getState);
            }, 1000);
          }
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success("User Group Successfully Created");
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.error("Failed to create new user group. Please try again");
        });
    }
    else {
      updateItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: GROUP_USER_EDIT_ACTION, payload: result.data });
          dispatch(saveUserAction(user, group));

          // Update user permissions based on group mobile access
          updateUserAppPermissions(user.contact_nr, group.tenantId, group.mobileAppAccess, getState);

          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success("User Group Successfully Updated");
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success("Failed to update the user group. Please try again");
        });
    }
  }
}

const saveUserAction = (user, group) => {
  const queryParams = {
    PK: `USERS`,
    SK: `USER%23${user.contact_nr}`,
  };
  return (dispatch, getState) => {
    const saveObject = new UserDTO(user);
    dispatch({ type: SAVE_IN_PROGRESS });
    return fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        let items = result.Items;
        items = items.filter((item) => item.status !== 'isDeleted');
        if (_.isEmpty(items)) {
          return createItemWs(saveObject, getState)
            .then((result) => {
              dispatch({ type: SAVE_PROCESS_DONE });
              dispatch(fetchGroupUserAction(group));
              return result;
            })
            .catch((err) => {
              console.log(err);
              dispatch({ type: SAVE_PROCESS_DONE });
              throw err;
            });
        }
        return Promise.resolve();
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  }
}

export const GROUP_USER_DELETE_ACTION = 'USER_GROUP_DELETE_ACTION';

export const deleteGroupUserAction = (user, userGroup) => {
  return (dispatch, getState) => {
    const saveObject = new GroupUserDTO(user, userGroup);
    saveObject.status = "isDeleted";
    dispatch({ type: SAVE_IN_PROGRESS });
    updateItemWs(saveObject, getState)
      .then((result) => {
        dispatch({ type: GROUP_USER_DELETE_ACTION, payload: result.data.id });

        // Remove user permissions if group has mobile access
        if (userGroup.mobileAppAccess) {
          console.log(`Removing permissions for user ${user.contact_nr} from tenant ${userGroup.tenantId}`);
          updateUserAppPermissions(user.contact_nr, userGroup.tenantId, false, getState);
        } else {
          console.log('Group does not have mobile access, skipping permission removal');
        }

        dispatch({ type: SAVE_PROCESS_DONE });
        toast.success("Group User Deleted Successfully");
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.error("Failed to delete user group. Please try again");
      });

  }
}

export const syncGroupUserPermissionsAction = (group) => {
  return (dispatch, getState) => {
    dispatch({ type: SAVE_IN_PROGRESS });

    const permissionData = {
      tenantId: group.tenantId,
      groupId: group.id,
      access: group.mobileAppAccess
    };

    grantGroupPermissions(permissionData, getState)
      .then(() => {
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.success("Group permissions synced successfully");
        toast.info("User permissions are being updated. This may take a few minutes to complete.");
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.error("Failed to sync group permissions");
      });
  };
};

export const uploadFileAction = (selectedFile, data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SAVE_IN_PROGRESS });
    await uploadFileTos3Action(selectedFile, data);

    dispatch(async (dispatch) => {
      try {
        await addUsersToGroups(data, getState);
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.success("Successfully uploaded file");
        toast.success("Please wait a few minutes for the users to be added to the group");
      } catch (error) {
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.error("Failed to upload the file. Please try again");
        throw error;
      }
    });
  } catch (error) {
    dispatch({ type: SAVE_PROCESS_DONE });
    toast.error("Failed to upload the file. Please try again");
    throw error;
  }
};

async function uploadFileTos3Action(selectedFile, data) {
  try {
    if (selectedFile !== undefined) {
      if (selectedFile.name.includes('.csv')) {
        await Storage.put(`${process.env.REACT_APP_ENV}/Groups/${data.tenantId}/${selectedFile.name}`, selectedFile, {
          level: 'public',
        });
      }
      else {
        throw new Error(`Unsupported file type: ${selectedFile.type}`);
      }
    }
    else {
      console.log("no file to upload!")
    }
  } catch (error) {
    throw error;
  }
}

/// Group Message Actions ///

export const FETCHING_GROUP_MESSAGES_ACTION = 'FETCHING_GROUP_MESSAGES_ACTION';
export const FETCH_GROUP_MESSAGES_SUCCESS_ACTION = 'FETCH_GROUP_MESSAGES_SUCCESS_ACTION';
export const FETCH_GROUP_MESSAGES_ERROR_ACTION = 'FETCH_GROUP_MESSAGES_ERROR_ACTION';

export const fetchGroupMessageAction = (group) => {
  const queryParams = {
    PK: `${group.tenantId}%23GROUP%23${group.id}`,
    SK: `NOTIFICATION%23`,
  };

  return (dispatch, getState) => {
    dispatch({ type: FETCHING_GROUP_MESSAGES_ACTION });
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        let items = result.Items;
        items = items.filter((item) => item.status !== 'isDeleted');
        dispatch({ type: FETCH_GROUP_MESSAGES_SUCCESS_ACTION, payload: items });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_GROUP_MESSAGES_ERROR_ACTION, err });
      });
  };
}


export const sendMessageAction = (message, userGroup, tenant) => {
  return (dispatch, getState) => {

    let notification = {}

    notification['message'] = {
      title: message.title,
      body: message.body
    }
    notification['senderData'] = {
      senderId: tenant.id,
      senderName: tenant.companyName ? tenant.companyName : tenant.name
    }
    notification['whatsAppTemplate'] = {
      whatsAppTemplate: message.whatsAppTemplate,
      whatsAppTemplatePlaceholderValues: message.whatsAppTemplatePlaceholderValues
    }
    notification['userGroup'] = userGroup
    notification['tenantName'] = tenant.name;

    sendGroupMessageWs(notification, getState)
      .then((result) => {
        dispatch(createMessageAction(message, userGroup, tenant, getState));
      })
      .catch((err) => {
        dispatch({ type: SAVE_PROCESS_DONE });
        console.log(err);
        toast.error("Failed To Send Message To Groups Memebers. Please Try Again");
      });
  }
}

export const GROUP_MESSAGE_ADD_ACTION = "GROUP_MESSAGE_ADD_ACTION";

export const createMessageAction = (message, userGroup, tenant) => {
  return (dispatch, getState) => {
    let senderData = {
      senderId: tenant.id,
      senderName: tenant.name
    }
    const saveObject = new GroupMessageDTO(message, userGroup, senderData);
    dispatch({ type: SAVE_IN_PROGRESS });
    createItemWs(saveObject, getState)
      .then((result) => {
        dispatch({ type: GROUP_MESSAGE_ADD_ACTION, payload: result.data });
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.success("Message Successfully Sent to Group Memebers");
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.error("Failed To Send Message To Group Memebers. Please Try Again");
      });
  }
}

// export const sendMessageAction = (message) => {
//   return (dispatch, getState) => {
//     sendGroupMessageWs(message, getState)
//       .then((result) => {
//         toast.success("Message Successfully Sent to Groups Memebers");
//       })
//       .catch((err) => {
//         console.log(err);
//         dispatch({ type: SAVE_PROCESS_DONE });
//         toast.error("Failed To Send Message To Groups Memebers. Please Try Again");
//       });
//   }
// }

// export const GROUP_MESSAGE_ADD_ACTION = "GROUP_MESSAGE_ADD_ACTION";

// export const createMessageAction = (message, userGroup, tenant) => {
//   return (dispatch, getState) => {
//     let senderData = {
//       senderId: tenant.id,
//       senderName: tenant.name
//     }
//     const saveObject = new GroupMessageDTO(message, userGroup, senderData);
//     dispatch({ type: SAVE_IN_PROGRESS });

//     // Promisify both createItemWs and sendGroupMessageWs
//     const createItemPromise = new Promise((resolve, reject) => {
//       createItemWs(saveObject, getState)
//         .then((result) => {
//           dispatch({ type: GROUP_MESSAGE_ADD_ACTION, payload: result.data });
//           resolve(result.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });

//     const sendMessagePromise = new Promise((resolve, reject) => {
//       createItemPromise.then((messageData) => {
//         sendGroupMessageWs(messageData, getState)
//           .then((result) => {
//             resolve(result.data);
//           })
//           .catch((err) => {
//             reject(err);
//           });
//       }).catch((err) => {
//         reject(err);
//       });
//     });

//     // Wait for both promises to resolve or reject
//     Promise.all([createItemPromise, sendMessagePromise])
//       .then(() => {
//         dispatch({ type: SAVE_PROCESS_DONE });
//         toast.success("Message Successfully Sent to Groups Members");
//       })
//       .catch((err) => {
//         console.log(err);
//         dispatch({ type: SAVE_PROCESS_DONE });
//         toast.error("Failed To Send Message To Groups Members. Please Try Again");
//       });
//   }
// }

